
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_CABLES: (state, payload) => state.cables = payload,

  SET_LINES: (state, payload) => state.lines = payload,
}